export default __webpack_public_path__ + "static/media/hidden.4bee39e7.png";